import { Injectable, ErrorHandler, Injector, NgZone } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import * as HttpStatusCodes from 'http-status-codes';
import { AuthenticationService } from './authentication.service';
import { ErrorMessage } from '../enums/respons-error-message-enum';

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
    constructor(
        private readonly injector: Injector,
        private readonly authService: AuthenticationService,
    ) { }

    handleError(error: any) {
        const ngZone = this.injector.get(NgZone);

        if (error instanceof HttpErrorResponse) {
            //Backend returns unsuccessful response codes such as 404, 500 etc.
            console.error('Backend returned status code: ', error.status);
            console.error('Response body:', error.message);
            if (error.status === HttpStatusCodes.UNAUTHORIZED) {
                ngZone.run(() => {
                    error.error.messages[0] === ErrorMessage.AccessDenied
                        ? this.authService.navigateToAccessDeniedPage()
                        : this.authService.logout();
                });
                return;
            }
        } else {
            //A client-side or network error occurred.
            console.error('An error occurred:', error.message);
            console.error('An error occurred:', error.stack);
        }
        ngZone.run(() => {
            console.error('handleError');
        });
    }
}
